import React from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../AppContext";
import Timer from "../../Components/Timer";
import Teleprompter from "../../Components/Teleprompter";
import ScriptInfo from "../../Components/ScriptInfo";
import CloseButton from "../../Misc/CloseButton";
import RecorderTimer from "../../Components/RecorderTimer";
import RecorderHotspot from "../../Components/RecorderHotspot";

var UiOverlay = function UiOverlay(_ref) {
  var AppContext = _ref.AppContext;
  var closeHandler = AppContext.closeHandler,
      startRehearsing = AppContext.startRehearsing,
      stopRecording = AppContext.stopRecording,
      toggleScriptEditor = AppContext.toggleScriptEditor,
      toggleTeleprompter = AppContext.toggleTeleprompter;
  var _AppContext$state = AppContext.state,
      script = _AppContext$state.script,
      scriptTextSize = _AppContext$state.scriptTextSize,
      scriptTextColor = _AppContext$state.scriptTextColor,
      isRecording = _AppContext$state.isRecording,
      isRehearsing = _AppContext$state.isRehearsing,
      teleprompterSpeed = _AppContext$state.teleprompterSpeed,
      autoStopTimeout = _AppContext$state.autoStopTimeout,
      recordedTime = _AppContext$state.recordedTime,
      hideTeleprompter = _AppContext$state.hideTeleprompter,
      executionTimer = _AppContext$state.executionTimer,
      showHotspot = _AppContext$state.showHotspot;
  return React.createElement("div", {
    className: "recorder__main"
  }, showHotspot && React.createElement(RecorderHotspot, null), React.createElement(CloseButton, {
    closeHandler: closeHandler
  }), script && React.createElement(ScriptInfo, {
    script: script.formatter ? script.formatter(script.text) : script.text,
    title: script.title,
    isTeleprompterHidden: hideTeleprompter,
    toggleTeleprompter: toggleTeleprompter,
    edit: toggleScriptEditor
  }), script && !hideTeleprompter && !showHotspot && React.createElement(Teleprompter, {
    script: script.formatter ? script.formatter(script.text) : script.text,
    isScrolling: isRecording || isRehearsing,
    fontSize: scriptTextSize,
    fontColor: scriptTextColor,
    speed: teleprompterSpeed,
    onRehearse: executionTimer ? null : startRehearsing,
    onScrollEnd: autoStopTimeout ? function () {
      return stopRecording(autoStopTimeout);
    } : null
  }), isRecording && React.createElement(Timer, {
    time: recordedTime
  }), executionTimer && React.createElement(RecorderTimer, {
    timeout: executionTimer.timeout,
    handler: executionTimer.handler
  }));
};

UiOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  AppContext: PropTypes.object.isRequired
} : {};
export default consumeContext(UiOverlay);